
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lessons/[slug]",
      function () {
        return require("private-next-pages/lessons/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lessons/[slug]"])
      });
    }
  